/**
 * account-label.ts — dòng phụ dưới tên người dùng ở menu trái: "<Tên tổ chức> · <Vai trò>".
 *
 * Tên tổ chức là của KHÁCH (tổ chức người dùng đang thuộc), không phải tên nền tảng/thương hiệu eCDP. Chưa có tên
 * (phiên vừa đăng nhập, `/auth/me` chưa về) → chỉ hiện vai trò, không điền tên nền tảng vào chỗ đó.
 */
export function accountSubtitle(orgName: string | null | undefined, roleLabel: string): string {
  const name = orgName?.trim()
  return name ? `${name} · ${roleLabel}` : roleLabel
}
